import React from "react";
import { Field } from "react-final-form";
import validate from "validate.js";
import Payment from "payment";
import moment from "moment";

import { createBrowserHistory } from "history";

export const history = createBrowserHistory();

export const Condition = ({ when, is, children }) => (
  <Field name={when} subscription={{ value: true }}>
    {({ input: { value } }) => (value === is ? children : null)}
  </Field>
);

export const Error = ({ name }) => (
  <Field name={name} subscription={{ error: true, touched: true }}>
    {({ meta: { error, touched } }) =>
      error && touched ? <div className="form_error">{error}</div> : null
    }
  </Field>
);

export const isEmail = (value) =>
  validate.single(value, {
    presence: true,
    email: true,
  });

export const minLen = (minimum) => (value) =>
  validate.single(value, {
    length: { minimum },
  });

export const isValidPhoneNumber = (value) =>
  /^[0-9\s]+$/.test(value) ? undefined : "Please enter a valid phone number";

export const required = (value) =>
  validate.single(value, {
    presence: { allowEmpty: false },
  })
    ? "This field is required"
    : undefined;

export const strongPassword = (string = "") => {
  const errors = ["Password must contain:"];
  if (!/[a-z]/.test(string)) {
    errors.push(" at least one lower case");
  }
  if (!/[A-Z]/.test(string)) {
    errors.push("at least one upper case");
  }
  if (!/[0-9]/.test(string)) {
    errors.push("at least one number");
  }
  if (!/[^a-zA-Z0-9]/.test(string)) {
    errors.push("at least one special character");
  }
  if (string.length < 8) {
    errors.push("at least 8 characters");
  }
  if (errors.length < 2) {
    return undefined;
  }
  let errorString = errors.join(", ").replace(":,", " ");
  errorString = errorString.replace(/,(?=[^,]+$)/, " and");
  return errorString;
};

export const mustBeNumber = (value) =>
  validate.isNumber(value) ? undefined : "Must be a number";

export const needsLogin = (isAuthed) => async (value) => {
  return undefined;
  // if (isAuthed) {
  // }
  // const exists = await AuthModel.uniqueEmail(value);

  // if (exists.exists === true) {
  //   return 'You already have an account with that email address. Please login to continue';
  // }
  // return undefined;
};

export const minValue = (min) => (value) =>
  validate.single(Number(value), {
    numericality: {
      greaterThanOrEqualTo: min,
    },
  });

export const hasPattern =
  (format, msg = "Does not match pattern") =>
  (value) =>
    validate.single(value, {
      format,
    })
      ? msg
      : undefined;

export const validCreditCard = (value) => {
  if (window.CBA.ValidateCardNumber(value) === false) {
    return "Please enter a valid credit card number";
  }

  const issuer = Payment.fns.cardType(value);
  if (!["visa", "mastercard"].includes(issuer)) {
    return "Please enter a valid VISA or Mastercard number";
  }

  return undefined;
};

export const validateExpiry = (value) => {
  const expiry = moment(value, "MM/YYYY");
  return window.CBA.ValidateExpiry(
    expiry.format("MM"),
    expiry.format("YYYY")
  ) === false
    ? "Invalid Expiry Date"
    : undefined;
};

export const ValidateCVC = (value) =>
  window.CBA.ValidateCVC(value) === false ? "Invalid CCV number" : undefined;

export const composeValidators =
  (...validators) =>
  (value) =>
    validators.reduce(
      (error, validator) => error || validator(value),
      undefined
    );

export const formatCreditCardNumber = (value) => {
  if (!value) {
    return value;
  }

  const issuer = Payment.fns.cardType(value);
  const clearValue = clearNumber(value);
  let nextValue;

  switch (issuer) {
    case "amex":
      nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(
        4,
        10
      )} ${clearValue.slice(10, 15)}`;
      break;
    case "dinersclub":
      nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(
        4,
        10
      )} ${clearValue.slice(10, 14)}`;
      break;
    default:
      nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(
        4,
        8
      )} ${clearValue.slice(8, 12)} ${clearValue.slice(12, 19)}`;
      break;
  }

  return nextValue.trim();
};

export function clearNumber(value = "") {
  return value.replace(/\D+/g, "");
}

export function formatCVC(value, allValues = {}) {
  const clearValue = clearNumber(value);
  let maxLength = 3;

  if (allValues.number) {
    const issuer = Payment.fns.cardType(allValues.number);
    maxLength = issuer === "amex" ? 4 : 3;
  }

  return clearValue.slice(0, maxLength);
}

export function formatExpirationDate(value) {
  const clearValue = clearNumber(value);

  if (clearValue.length >= 3) {
    return `${clearValue.slice(0, 2)}/${clearValue.slice(2, 4)}`;
  }

  return clearValue;
}

export const ucFirst = (s) =>
  s ? s.substr(0, 1).toUpperCase() + s.substr(1).toLowerCase() : undefined;
